let BlueprintProperties = {
    attributes: {
        name: 'attributes',
        children: {
            // className: { name: 'className'},
            // id: { name: 'id'},
            // href: { name: 'href'},
            // placeholder: {name: 'placeholder'},
            // value: {name: 'value'},
            // d: { name: 'd'},
            // cx: { name: 'cx'},
            // cy: { name: 'cy'},
            // r: { name: 'r'},
        }
    },
    data: {name: 'data'},
    style: {name: 'style'},
    transform: {
        name: 'transform',
        children: {
            position: {
                name: 'position',
                children: {x: {name: 'x'}, y: {name: 'y'} }
            },
            scale: {
                name: 'scale',
                children: {x: {name: 'x'}, y: {name: 'y'} }
            },
            rotation: {name: 'rotation'}
        }
    },
    content: {name: 'content'},
    html: {name: 'html'}
};

export default BlueprintProperties;